exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* mobile stops at 767px, tablet starts at 768px */\n/* tablet stops at 1023px, desktop starts at 1024px */\n/* desktop stops at 1439px, cinema starts at 1440px */\n/* for bigger screen, starts at 2400px */\n/* DPlus is moving to a scalable design based on viewport widths */\n", ""]);

// exports
exports.locals = {
	"mediaBreakXsmall": "480px",
	"mediaBreakSmall": "768px",
	"mediaBreakMedium": "1024px",
	"mediaBreakLarge": "1440px",
	"mediaBreakXlarge": "1600px",
	"mediaBreakShort": "480px",
	"marginMobile": "6.4vw",
	"marginTablet": "5.2083vw",
	"marginDesktop": "4.5vw",
	"marginCinema": "3.5vw",
	"gapMobile": "3.2vw",
	"gapTablet": "1.5625vw",
	"gapDesktop": "1.25vw",
	"gapCinema": "1vw",
	"widthMobile": "calc(100vw - 2 * 6.4vw)",
	"widthTablet": "calc(100vw - 2 * 5.2083vw)",
	"widthDesktop": "calc(100vw - 2 * 4.5vw)",
	"widthCinema": "calc(100vw - 2 * 3.5vw)"
};